import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import './App.scss';
import { AppProvider } from './AppContext';
import { Buttons, Content, Footer, Particles, Toggle } from 'components';
import { config } from './config';
import Projects from './pages/Projects'; // Import the Projects component
import AboutMe from './pages/AboutMe';
import Blog from './pages/Blog';
import FirstBlog from './pages/first_blog';
import AlexNet from './pages/alexnet';
import Siamese from './pages/siamese';
import Xception from './pages/xception';
import DrippedUp1 from './pages/drippedup1';
import DrippedUp2 from './pages/drippedup2';
import MeteorBlog from './pages/meteor_blog';
import MoralityLLMs from './pages/morality_llms';
import HHHLimits from './pages/hhh_limits';
import AIBuildsItself from './pages/ai_builds_itself';

export const App = () => {
  const [isReady, setIsReady]: [boolean, Function] = useState(false);
  const [isMobile, setIsMobile]: [boolean, Function] = useState(false);

  const init = () => {
    if (
      window.matchMedia(
        '(max-device-width: 820px) and (-webkit-min-device-pixel-ratio: 2)',
      )?.matches
    ) {
      setIsMobile(true);
    }

    const localStorageTheme: string | null = localStorage.getItem('theme');
    if (localStorageTheme === 'true') {
      localStorage.setItem('theme', 'dark');
    } else if (localStorageTheme === 'false') {
      localStorage.setItem('theme', 'light');
    }

    setIsReady(true);
  };

  useEffect(() => {
    if (!isReady) init();
  }, [isReady]);

  if (!isReady) {
    return null; // This ensures nothing renders until the app is ready
  }

  return (
    <AppProvider config={config} isMobile={isMobile}>
      <Router>
        <main className="app">
          
          <Routes>

            <Route
              path="/"
              element={
                <>
                  <Toggle />
                  <Content />
                  <Buttons />
                  <Particles />
 
                </>
              }
            />
            <Route path="/projects" element={<Projects />} />
            <Route path="/aboutme" element={<AboutMe />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/first-blog" element={<FirstBlog />} />
            <Route path="/alexnet" element={<AlexNet />} />
            <Route path="/siamese" element={<Siamese />} />
            <Route path="/xception" element={<Xception />} />
            <Route path="/drippedup1" element={<DrippedUp1 />} />
            <Route path="/drippedup2" element={<DrippedUp2 />} />
            <Route path="/meteor-blog" element={<MeteorBlog />} />
            <Route path="/morality-llms" element={<MoralityLLMs />} />
            <Route path="/hhh-limits-rlhf" element={<HHHLimits />} />
            <Route path="/ai-builds-itself" element={<AIBuildsItself />} />
          </Routes>

          <Footer />
        </main>
      </Router>
    </AppProvider>
  );
};
